<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="1000px">
      <v-form ref="addGoals" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>{{ action }} Goals</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    label="Goals Description"
                    outlined
                    v-model="goal_description"
                    dense
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="vp"
                    :rules="[formRules.required]"
                    dense
                    outlined
                    class="rounded-lg"
                    item-text="description"
                    item-value="id"
                    label="VP's"
                    color="#6DB249"
                    :items="vpList"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>

            <v-btn
              v-if="action == 'Add'"
              color="#519043"
              class="white--text"
              @click="addnew()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
            <v-btn
              v-if="action == 'Update'"
              color="#519043"
              class="white--text"
              @click="update()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    action: null,
  },

  data() {
    return {
      id: null,
      spID: null,
      goal_description: null,
      target_accomplishment: null,
      linked: null,
      vp: null,
      vpList: [],
      dialog: false,
      isSubmitLoading: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.initialize();
        this.dialog = true;
        console.log("Data", data);
        if (data.id) {
          this.id = data.id;
          this.vp = data.strategic_planning_vp_goal_roleID.toString();
          this.goal_description = data.description;
        } else {
          this.id = null;
          this.vp = null;
          this.goal_description = null;
        }
      },

      deep: true,
    },
  },

  methods: {
    initialize() {
      this.axiosCall("/strategic-planning-goal/", "GET").then((res) => {
        if (res) {
          this.vpList = res.data;
          console.log(res.data);
        }
      });
    },

    closeD() {
      this.eventHub.$emit("closeaddGoals", false);
      this.isSubmitLoading = false;
      this.dialog = false;
    },

    addnew() {
      if (this.$refs.addGoals.validate()) {
        this.isSubmitLoading = true;
        let arr = [];
        for (let i = 0; i < this.vpList.length; i++) {
          if (this.vp == this.vpList[i].id) {
            arr.push(this.vpList[i]);
          }
        }
        let data = {
          strat_planID: this.data.spID,
          strategic_planning_vp_goal_roleID: arr[0].id,
          strategic_planning_vp_goal_roleOfficeID: arr[0].vp_officeID,
          description: this.goal_description,
          vp_goal_role_description: arr[0].description,
        };
        // console.log(data);
        this.axiosCall("/strategic-planning-goal", "POST", data).then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            if (res.data.count) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        });
      }
    },

    update() {
      console.log("Update Data");
      if (this.$refs.addGoals.validate()) {
        this.isSubmitLoading = true;
        let arr = [];
        for (let i = 0; i < this.vpList.length; i++) {
          if (this.vp == this.vpList[i].id) {
            arr.push(this.vpList[i]);
          }
        }
        let data = {
          strategic_planning_vp_goal_roleID: arr[0].id,
          strategic_planning_vp_goal_roleOfficeID: arr[0].vp_officeID,
          description: this.goal_description,
          vp_goal_role_description: arr[0].description,
        };
        // console.log(data);
        this.axiosCall(
          "/strategic-planning-goal/" + this.id,
          "PATCH",
          data
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
  },
};
</script>
